<template>
    <tbody>
      <tr v-for="(food, index) in foods" v-bind:key="index">
        <td>
          <a href="#" @click.prevent="deleteFoodFromMeal(food)"><i class="mdi mdi-close"></i></a>
        </td>
        <td>{{ food.name }}</td>
        <td class="text-right">
          <a href="#"
            @click.prevent="startEditingFoodAmount(food)">
            <!-- v-show="foodAmountEditId != food.pivot.id"> -->
            <!-- {{food.pivot.amount | toFixed(3) }} -->
            {{food.pivot.amount | trimDecimal }}
            {{ food.pivot.food_weight_name }}
          </a>
          <!-- <input type="number"
            :id="'edit-food-amount-'+food.pivot.id"
            v-model="newAmount"
            v-show="foodAmountEditId == food.pivot.id"
            @keydown.enter="updateFoodAmount(food)"
            @keydown.esc="cancelEditingFoodAmount"
            @blur="cancelEditingFoodAmount"
            min="0"
            max="500"
            interval="1"
            style="height: 24px; width: 60px; padding: 2px 1px; font-size: 15px;"> -->
        </td>
        <td class="text-right">{{ food.pivot.calories | toFixed(0) }}</td>
        <td class="text-right">{{ food.pivot.protein_g | toFixed(0) }}</td>
        <td class="text-right">{{ food.pivot.carbohydrate_g | toFixed(0) }}</td>
        <td class="text-right">{{ food.pivot.fat_g | toFixed(0) }}</td>
      </tr>

      <modal v-if="showEditFoodModal" @close="closeEditFoodModal()">
        <h3 slot="header">Edit {{ FoodToEdit ? FoodToEdit.name : 'Food' }}</h3>
        <div slot="body">
            <div v-if="FoodToEdit">
                <!-- <h2>{{ FoodToEdit.name }}</h2> -->
                <!-- <h2>{{ FoodToEdit }}</h2> -->
                <div class="form-row align-items-center mb-2">

                    <div class="col-auto">
                      <label for="food_to_add_weight_select">Unit</label>
                      <!-- <div class="form-group"> -->
                        <select id="food_to_add_weight_select" class="form-control" v-model="FoodToEditFoodWeight">
                          <option disabled value="">Please select one</option>
                          <!-- v-for="foodWeight in FoodToEdit.food_weights" -->
                          <option
                            v-for="foodWeight in getFoodWeightsForFoodId(FoodToEdit.id)"
                            v-bind:key="foodWeight.id"
                            :value="foodWeight"
                            >{{foodWeight.name }} <template v-if="foodWeight.name!='grams'">({{ foodWeight.grams | trimDecimal }}g)</template>
                            <!-- <span>({{ foodWeight.type }})</span> -->
                          </option>
                        </select>
                      <!-- </div> -->
                    </div>

                    <div class="col-auto">
                        <label for="food-to-add-amount">Amount</label>
                        <input type="number" id="food-to-add-amount" :step="foodToAddAmountStep" min="0" class="form-control" :placeholder="foodToAddAmountPlaceholder" required v-model="FoodToEditAmount" :disabled="!FoodToEditFoodWeight">
                    </div>

                    <!-- <div class="col-auto">
                        <button @click="setFoodToEditMax()" class="btn btn-secondary"><i class="mdi mdi-gas-station"></i> Fill 'er up!</button>
                    </div> -->
                </div>
                <div class="my-2">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th class="text-right" scope="col"></th>
                                <th class="text-right" scope="col">Cals</th>
                                <th class="text-right" scope="col">Prot (g)</th>
                                <th class="text-right" scope="col">Carbs (g)</th>
                                <th class="text-right" scope="col">Fat (g)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>This: </td>
                                <td class="text-right">{{ food_calories_for_amount(FoodToEdit, FoodToEditAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_protein_for_amount(FoodToEdit, FoodToEditAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_carbohydrate_for_amount(FoodToEdit, FoodToEditAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_fat_for_amount(FoodToEdit, FoodToEditAmount) | toFixed(0) }}</td>
                            </tr>
                            <tr>
                                <td align="text-right" class="text-muted">Target:</td>
                                <td class="text-right">{{ meal.target_calories-meal.calories | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_protein_g-meal.protein_g | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_carbohydrate_g-meal.carbohydrate_g | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_fat_g-meal.fat_g | toFixed(0) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="">
                    <button @click="updateFoodAmount()" class="btn btn-primary" :disabled="FoodToEditAmount > 0 && FoodToEditAmount <= 9999 ? false : true">Update Food Amount</button>
                    <!-- <button @click="FoodToEdit=null;FoodToEditAmount=null;" class="btn btn-default">Change Food</button> -->
                </div>
            </div>
        </div>
        <div slot="footer">
          <button class="btn btn-default" @click="closeEditFoodModal()">
            Cancel
          </button>
        </div>
    </modal>
    </tbody>

</template>
<script>
  export default {
    data() {
      return {
        // foodAmountEditId: -1,
        // newAmount: 0,
        showEditFoodModal: false,
        FoodToEdit: null,
        FoodToEditFoodWeight: null,
        // FoodToEditFoodWeightId: null,
        FoodToEditAmount: null,
      }
    },
    computed: {
      foodToAddAmountPlaceholder: function(){
        var unit = "unit";
        if (this.FoodToEditFoodWeight) {
          unit = this.FoodToEditFoodWeight.name
        }
        return "Amount of " + unit;
      },
      foodToAddAmountStep: function(){
        var step = 1;
        if (this.FoodToEditFoodWeight && this.FoodToEditFoodWeight.default_increment_amount) {
          step = this.FoodToEditFoodWeight.default_increment_amount;
        }
        return step;
      },
    },
    methods: {
      getFoodWeightFromId: function(food_weight_id) {
        var result = _.find(this.$root.allFoodWeights, function(food_weight) {
            return food_weight.id == food_weight_id;
        })
        // console.log("Looking for Food Weight ID: " + food_weight_id);
        // console.log(result);
        return result;
      },
      getFoodWeightsForFoodId: function(food_id) {
        var result = _.filter(this.$root.allFoodWeights, function(foodWeight) {
            return foodWeight.food_id == food_id;
        })
        // console.log("Looking for Food Weight ID: " + food_weight_id);
        // console.log(result);
        return result;
      },
      deleteFoodFromMeal(food) {
        var _this = this;
        Vue.set(_this.$parent.meal, 'isLoading', true);
        axios.delete('/api/meal_plan_day_meal_foods/' + food.pivot.id, {})
          .then(function (response) {
              _this.$emit('food-updated', food.pivot.id);
          })
          .catch(e => {
            _this.$toasted.error(e.response.data.message);
            Vue.set(_this.$parent.meal, 'isLoading', false);
          });
      },
      closeEditFoodModal(){
        this.showEditFoodModal=false;
      },
      startEditingFoodAmount(food) {
        console.log(food)
        this.showEditFoodModal = true;
        this.FoodToEdit = food;
        // this.FoodToEditFoodWeightId = food.pivot.food_weight_id;
        this.FoodToEditFoodWeight = this.getFoodWeightFromId(food.pivot.food_weight_id);
        // this.FoodToEditAmount = food.pivot.amount;
        // Just for pretty formatting
        this.FoodToEditAmount = this.$options.filters.trimDecimal(food.pivot.amount);
        // console.log("FoodToEditAmount");
        // console.log(this.FoodToEditAmount);

        // console.log("Food Weights");
        // console.log(this.getFoodWeightsForFoodId(this.FoodToEdit.id));
        // this.foodAmountEditId = food.pivot.id;
        // this.newAmount = Vue.options.filters.toFixed(food.pivot.amount, 0);
        this.$nextTick(function(){
          document.getElementById('food-to-add-amount').focus();
        }.bind(this))
      },
      // startEditingFoodAmount(food) {
      //   this.foodAmountEditId = food.pivot.id;
      //   this.newAmount = Vue.options.filters.toFixed(food.pivot.amount, 0);
      //   this.$nextTick(function(){
      //     document.getElementById('edit-food-amount-'+this.foodAmountEditId).focus();
      //   }.bind(this))
      // },
      stopEditingFoodAmount() {
        this.showEditFoodModal = false;
        this.FoodToEdit = null;
        this.FoodToEditFoodWeight = null;
        this.FoodToEditAmount = null;

      },
      updateFoodAmount() {
        var _this = this;
        Vue.set(_this.$parent.meal, 'isLoading', true);
        // _this.foodAmountEditId = -1;

        axios.put('/api/meal_plan_day_meal_foods/' + _this.FoodToEdit.pivot.id,
          {
            "amount": _this.FoodToEditAmount,
            "food_weight_id": _this.FoodToEditFoodWeight.id
          })
          .then(function (response) {
            // food.pivot.amount = _this.FoodToEditAmount // Avoid FOUC
            _this.stopEditingFoodAmount();
            _this.$emit('food-updated');
          })
          .catch(e => {
            console.log("Error?");
            console.log(e);
            _this.$toasted.error(e.response.data.message);
            // _this.newAmount = food.pivot.amount;
            Vue.set(_this.$parent.meal, 'isLoading', false);
          });
      },
      // updateFoodAmount(food) {
      //   var _this = this;
      //   Vue.set(_this.$parent.meal, 'isLoading', true);
      //   _this.foodAmountEditId = -1;

      //   axios.put('/api/meal_plan_day_meal_foods/' + food.pivot.id,
      //     {"amount": _this.newAmount})
      //     .then(function (response) {
      //       food.pivot.amount = _this.newAmount // Avoid FOUC
      //       _this.$emit('food-updated', food.pivot.id);
      //     })
      //     .catch(e => {
      //       _this.$toasted.error(e.response.data.message);
      //       _this.newAmount = food.pivot.amount;
      //       Vue.set(_this.$parent.meal, 'isLoading', false);
      //     });
      // },
      // cancelEditingFoodAmount() {
      //   this.foodAmountEditId = -1
      // },
      foodToAddFoodWeightGrams(){
        return (this.FoodToEditFoodWeight.grams / this.FoodToEditFoodWeight.amount) * this.FoodToEditAmount;
      },
      food_calories_for_amount(food, amount) {
        if (!this.FoodToEditFoodWeight) { return 0; }
        return (food.calories_per_100g/100)*this.foodToAddFoodWeightGrams();
      },
      food_protein_for_amount(food, amount) {
        if (!this.FoodToEditFoodWeight) { return 0; }
        return (food.protein_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.protein_g/100)*amount;
      },
      food_carbohydrate_for_amount(food, amount) {
        if (!this.FoodToEditFoodWeight) { return 0; }
        return (food.carbohydrate_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.carbohydrate_g/100)*amount;
      },
      food_fat_for_amount(food, amount) {
        if (!this.FoodToEditFoodWeight) { return 0; }
        return (food.fat_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.fat_g/100)*amount;
      },
    },
    props: [
      'foods',
      'meal'
    ],
    filters: {
      // properCase(string) {
      //   return string.charAt(0).toUpperCase() + string.slice(1);
      // }
    }
  }
</script>
<style></style>
